module.exports = __webpack_public_path__ + "static/img/Reschedule_an_Appointment_for_a_Patient.a27fc03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Reschedule_an_Appointment_for_a_Patient.jpg
// module id = andu
// module chunks = 0